import { buildApiUrl, buildHeaders, handleResponse } from '@/network/api-client';
import type { BiographyApi, BiographySnapshot } from '../types/biography.types';
export const biographyApi: BiographyApi = {
  async snapshot(signal) { return handleResponse<BiographySnapshot>(await fetch(buildApiUrl('/hero/biography'), { headers: buildHeaders(), cache: 'no-store', signal })); },
  async submit(command, signal) { return handleResponse(await fetch(buildApiUrl('/hero/biography/messages'), { method: 'POST', headers: buildHeaders(), body: JSON.stringify(command), signal })); },
};
